//  For each product on the page
document.querySelectorAll('.productV3').forEach(section => {

    const product = JSON.parse(section.querySelector(".productV3JSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);

    // product has subscription
    const hasSubscription = product.selling_plan_groups.length > 0;


    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.productV3 = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

        // if single image instead of swiper, don't load
    let swiperExists = false;
    let productSwiper;
    if (!section.querySelector('.productV3VisualSingle')) {

        // mark these
        swiperExists = true;

        productSwiper = new Swiper(section.querySelector(".productV3VisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true,
            on: {
                slideChange: function () {
                    if (!section.querySelector(".productV3VisualSwiperSlide")) {
                        return;
                    }

                    // pause all videos
                    section.querySelectorAll(".productV3VisualSwiperSlide video").forEach(element => {
                        element.pause();
                    });
                }
            }
        });

        // play video on slide play click
        section.querySelectorAll(".productV3VisualSwiperSlide")?.forEach(element => {
            element.addEventListener("click", function () {
                // get video
                const video = this.closest(".productV3VisualSwiperSlide").querySelector("video");

                if (!video) {
                    return;
                }

                // remove play button if it hasn't already been removed
                this.querySelector(".productV3VisualSwiperSlidePlay")?.remove();

                // show controls
                video.controls = true;

                // play video
                video.play();
            });
        });

        // change slide on thumbnail click
        section.querySelectorAll(".productV3VisualThumbsSlide")?.forEach(element => {
            element.addEventListener("click", function () {
                // change slide
                productSwiper.slideTo(this.dataset.index - 1);
            });
        });
    }

    /**************
     Quantity
     ***************/

    let quantity = 1;

    // quantity buttons
    section.querySelectorAll('.productV3QuantityButton').forEach(button => {
        button.addEventListener('click', function () {
            if (this.classList.contains('productV3QuantityButtonRemove')) {
                if (quantity === 1) return;
                quantity--;
            } else {
                quantity++
            }
            // update the display
            section.querySelector('.productV3QuantityText').textContent = String(quantity);
        })
    })

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productV3SellingOptionInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productV3SellingOptionPlan').value);
    }

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", async function () {
            // check for single image layout and variant images
            if (element.classList.contains('imageSwap')) {
                // swap active images
                section.querySelector('.productV3VisualSingle.active')?.classList.remove('active');
                section.querySelector(`.productV3VisualSingle[data-value="${element.value}"]`)?.classList.add('active');
            }

            // create array of selected option ids
            const optionIDs = [];
            section.querySelectorAll(".productV3OptionsValuesLabelInput:checked").forEach(element => {
                optionIDs.push(element.dataset.valueId);
            })

            // fetch updated variant data
            activeVariant = await fetch(`${window.location.pathname}?view=active-variant&option_values=${optionIDs.join(',')}`)
                .then(response => response.json());

            updateProduct().catch(e => console.error(e));
        });
    })

    async function updateProduct() {
        // check if variant wasn't found
        if (!activeVariant.id) {
            section.querySelectorAll(".productV3ATC").forEach(button => button.disabled = true);
            section.querySelectorAll(".productV3ATCText").forEach(button => button.textContent = "NOT AVAILABLE");
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image && swiperExists) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

        let allocationPrice = activeVariant?.selling_plan_allocations[0]?.price * quantity || 0;
        let originalPrice = activeVariant.price * quantity;
        let discountedPrice = activeVariant.price * quantity;
        let compareAt = activeVariant.compare_at_price * quantity || 0;

        // if there's a subscription we need to update both prices
        if (hasSubscription) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productV3SellingOptionHeaderPriceCompare");
            const reals = section.querySelectorAll(".productV3SellingOptionHeaderPriceReal");

            // Destructure them for clarity, otp comes first on DOM
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;

            // Update subscription prices
            originalPrice > allocationPrice ? subCompare.textContent = price(originalPrice) : subCompare.textContent = "";
            subReal.textContent = price(allocationPrice);

            // Update one-time purchase prices
            if (compareAt > discountedPrice) {
                oneTimeCompare.textContent = price(compareAt);
            } else if (originalPrice > discountedPrice) {
                oneTimeCompare.textContent = price(originalPrice);
            } else {
                oneTimeCompare.textContent = "";
            }
            oneTimeReal.textContent = price(discountedPrice);

        } else {
            // Non-subscription scenario
            const compareEl = section.querySelector(".productV3SellingOptionHeaderPriceCompare");
            const realEl = section.querySelector(".productV3SellingOptionHeaderPriceReal");

            // check that the OTC is included
            if (realEl) {
                if (compareAt > discountedPrice) {
                    compareEl.textContent = price(compareAt);
                } else if (originalPrice > discountedPrice) {
                    compareEl.textContent = price(originalPrice);
                }
                realEl.textContent = price(discountedPrice);
            }
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelectorAll(".productV3ATC").forEach(button => button.disabled = false);
            section.querySelectorAll(".productV3ATCText").forEach(button => button.textContent = "ADD TO CART");
        } else {
            section.querySelectorAll(".productV3ATC").forEach(button => button.disabled = true);
            section.querySelectorAll(".productV3ATCText").forEach(button => button.textContent = "SOLD OUT");
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(e => console.error(e));

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelectorAll(".productV3ATC").forEach(atc => atc.classList.add("loading"));

        // see if the selected variant is a pre-order item
        const properties = {};
        if (section.querySelector('.productV3OptionsValuesLabelInput:checked')?.dataset?.message) {
            properties.Preorder = section.querySelector('.productV3OptionsValuesLabelInput:checked')?.dataset?.message;
        }

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
                properties: properties
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = currentSellingPlan();
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelectorAll(".productV3ATC").forEach(atc => atc.classList.remove("loading"));

        // open cart
        await openCart();
    }

    section.querySelectorAll('.productV3ATC').forEach(atc => atc.addEventListener("click", addToCart));

    /***********
     Sticky ATC
     ************/

        // when the regular atc is on screen, hide the sticky atc
    const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    section.querySelector('.productV3Sticky').classList.remove('active');
                } else {
                    section.querySelector('.productV3Sticky').classList.add('active');
                }
            });
        }, {threshold: 0.1});

    observer.observe(section.querySelector('.productV3purchaseATC'));

});